import Home from "@components/Home"
import type { SupportedLocale as Lang } from "@site-types/site"

export function HomePage({ locale }: { locale: Lang }) {
  return <Home locale={locale} />
}
